module.exports = __webpack_public_path__ + "img/history_timeline_2.a5bb54d4.png";